var render = function render(){var _vm=this,_c=_vm._self._c;return _c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.msg),expression:"msg"}],staticClass:"c-form_error"},[_vm._v(_vm._s(_vm.msg))])
}
var staticRenderFns = []

export { render, staticRenderFns }